import React from 'react';

import { SelfViewControlsLayerRendererProps } from '@yandex-video-platform/goloom-sdk-react';
import { useSelector } from 'react-redux';

import { SELF } from '../../../../../shared/constants';
import { goloomSdk } from '../../../../../shared/features/goloom-sdk';
import { useVideoOrientation } from '../../../../../shared/hooks/useVideoOrientation';
import { useLocalVad } from '../../../hooks/goloom-local-vad';
import { selectNetworkQualityType } from '../../../selectors';
import { ParticipantLayer } from './participant-layer';

export const SelfViewControlsLayer: React.FC<SelfViewControlsLayerRendererProps> = ({
    videoElementRef,
    isVideoReady,
}) => {
    const isVAD = useLocalVad();
    const networkQualityType = useSelector(selectNetworkQualityType);
    const videoStatus = goloomSdk.session?.videoStatus;

    useVideoOrientation(videoElementRef.current);

    return (
        <ParticipantLayer
            userId={SELF}
            isVAD={isVAD}
            networkQualityType={networkQualityType}
            isVideoReady={isVideoReady}
            isCameraEnabled={videoStatus}
        />
    );
};
